import { chipColors } from "components/Form/Chip"
import { ratingColors, ratingColors3 } from "./rating"

const priority = {
    'high': "HIGH",
    'medium': "MEDIUM",
    'low': 'LOW'
}

const priorityOptions = [
    { id: priority.low, name: "נמוך", label: "חשוב", ...chipColors.thirdly, width: 80 },
    { id: priority.medium, name: "בינוני", label: "דחוף", ...chipColors.secondary, width: 92 },
    { id: priority.high, name: "גבוה", label: "דחוף מאד - זה תוקע אותי", ...chipColors.pink, width: 80 },
]

export { priorityOptions }
export default priority